<div class="user-management permission-settings">
  <div class="action-tabs-container">
    <div class="custom-tabs">
      <div
        class="custom-tab"
        [ngClass]="{ active: activeTab === 'permissions' }"
        (click)="navigateToTab('permissions')"
      >
       Permission group
      </div>
      <!-- <div
        class="custom-tab"
        [ngClass]="{ active: activeTab === 'permission-groups' }"
        (click)="navigateToTab('permission-groups')"
      >
        User permission
      </div> -->
    </div>
  </div>

  <div class="tab-content-container">
    <router-outlet></router-outlet>
  </div>
</div>
